import React from 'react';
import BlogListGeneric from '../../Generic/BlogListGeneric';

const BlogListIT = () => {
    return (
      <BlogListGeneric postType="IT" heading="Information Technology Alerts" />
  );
};

export default BlogListIT;